/*eslint-disable */

import {bus} from '@/main';
import countries from '@/services/country.json'
import {
  mapGetters
} from 'vuex';
import ngoJoinRequestPopup from '@/components/lbilAdmin/apporve-request-for-sg';

export default {
  name: 'sg-list',
  components: {
    'join-request-popup' : ngoJoinRequestPopup
  },
  props: [],
  data () {
    return {
      ngoInfoData:null,
      ngoInfoDataResults:[],
      countryList:[],
      joinRequestPopupState:false,
      joinNgoInfo:null,
      popupFlag:'',
      ngoPublicInfoData:null,
      ngoPublicInfoDataResults:[],
    }
  },
  computed: {
    ...mapGetters([
      'getLBILSGListGetters',
      'getLBILPublicSGListGetters'
    ]),
    getNgoInfoDataFun(){
     this.ngoInfoData = this.$store.getters.getLBILSGListGetters.data
     return;
    },
    setInitialStatesOfNGoFun() {
      if (this.ngoInfoData) {
        this.ngoInfoDataResults = this.ngoInfoData.results
      }
      return;
    },
    getNgoPublicInfoDataFun(){
     this.ngoPublicInfoData = this.$store.getters.getLBILPublicSGListGetters.data
     return;
    },
    setInitialStatesOfPublicNGoFun() {
      if (this.ngoPublicInfoData) {
        this.ngoPublicInfoDataResults = this.ngoPublicInfoData.results
      }
      return;
    },
  },
  mounted(){
    this.getNgoInfoDataFun
    this.setInitialStatesOfNGoFun 
    this.getNgoPublicInfoDataFun
    this.setInitialStatesOfPublicNGoFun 
    bus.$on('joinRequestRecordModalBus', (data) => {
      this.joinRequestPopupState = data
    });
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
  },
  methods: {
    joinRequestPopupOpenMethod(info, flag){
      this.popupFlag = flag
      this.joinNgoInfo = info
      document.body.classList.add('body_right_scroll_remove')
      this.joinRequestPopupState = true
    },
    getCountryNameFun(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    getNgoInfoDataFun(){
      return this.$store.getters.getLBILSGListGetters;
    },
    setInitialStatesOfNGoFun(){
      if (this.ngoInfoData) {
        this.ngoInfoDataResults =  this.ngoInfoData.results
      }
      return;
    },
    getNgoPublicInfoDataFun(){
     return this.$store.getters.getLBILPublicSGListGetters;
    },
    setInitialStatesOfNGoFun() {
      if (this.ngoPublicInfoData) {
        this.ngoPublicInfoDataResults = this.ngoPublicInfoData.results
      }
      return;
    },
  }
}